<template>
  <div>
    <CampTab :index="index" @tap="tapFn"></CampTab>
    <el-row :gutter="15">
      <el-col :span="24" v-if="index === 1">
        <el-card>
          <!-- <el-row class="title_row">
            <el-col>
              <span class="title_class">洲际挑战赛</span>
            </el-col>
          </el-row> -->
          <el-row :gutter="15">
            <el-col :span="6" v-for="(item, i) in summerCampList" :key="i">
              <div class="camp-item" @click="goCampCampersData(item.id)">
                <div class="status" v-if="!item.closeStatus">已闭营</div>
                <img class="bg" :class="!item.closeStatus ? 'op' : ''" :src="item.coverUrl" alt="">
                <div class="panel">
                  <div class="name">{{item.period}}｜{{ item.name }}</div>
                  <div class="flex">
                    <div>{{ item.place }}</div>
                    <div>{{ item.duration }}</div>
                  </div>
                  <div class="date">{{ formatDate(item.startTime) }}/{{ formatDate2(item.endTime) }}</div>
                  <!-- <div class="btns">
                    <div class="btn" @click="handleToPage(item)">报名列表</div>
                    <div class="btn" @click="handleToPage2(item)">设置折扣</div>
                  </div> -->
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" v-if="index === 0">
        <el-card>
          <!-- <el-row class="title_row">
            <el-col>
              <span class="title_class">SPBCN冠军冬训营</span>
            </el-col>
          </el-row> -->
          <el-row :gutter="15">
            <el-col :span="6" v-for="(item, i) in winnerCampList" :key="i">
              <div class="camp-item" @click="goCampCampersData(item.id)">
                <div class="status" v-if="!item.closeStatus">已闭营</div>
                <img class="bg" :class="!item.closeStatus ? 'op' : ''" :src="item.coverUrl" alt="">
                <div class="panel">
                  <div class="name">{{item.period}}｜{{ item.name }}</div>
                  <div class="flex">
                    <div>{{ item.place }}</div>
                    <div>{{ item.duration }}</div>
                  </div>
                  <div class="date">{{ formatDate(item.startTime) }}/{{ formatDate2(item.endTime) }}</div>
                  <!-- <div class="btns">
                    <div class="btn" @click="handleToPage(item)">报名列表</div>
                    <div class="btn" @click="handleToPage2(item)">设置折扣</div>
                  </div> -->
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="15" style="margin-top: 15px">
      <el-col :span="12">
        <el-card>
          <el-row class="title_row">
            <el-col>
              <span class="title_class">信息管理</span>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col style="margin-top: 30px" :span="12" v-for="(item, i) of racingToolList" v-bind:key="i">
              <gameToolBackView :itemData="item" :key="i" @itemClicked="racingToolClicked"></gameToolBackView>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <el-row class="title_row">
            <el-col>
              <span class="title_class">客户咨询</span>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col style="margin-top: 30px" :span="12" v-for="(item, i) of racingToolList2" v-bind:key="i">
              <gameToolBackView :itemData="item" :key="i" @itemClicked="racingToolClicked"></gameToolBackView>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <!-- <el-card style="margin-top: 15px;" v-if="index === 0">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">审核管理</span>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col style="margin-top: 30px" :span="6" v-for="(item, i) of nasccList" v-bind:key="i">
          <gameToolBackView :itemData="item" :key="i" @itemClicked="racingToolClicked"></gameToolBackView>
        </el-col>
      </el-row>
    </el-card> -->
  </div>
</template>

<script>
import { camPage } from '@/http/api'
import CampTab from '@/components/camp_tab_component.vue'

export default {
  components: {
    CampTab
  },
  data () {
    return {
      index: 0,
      racingToolList: [
        {
          rightTitle: '营地信息管理',
          rightDesc: '查看营地信息',
          icon: 'icon-cuoqingdengji',
          menuTag: '1',
          flag: this.$chnEngStatusCode.camp_list_data,
          turnUrl: '/raceManagement/camp/campListData'
        },
        {
          rightTitle: '报名信息统计',
          rightDesc: '查看报名数据',
          icon: 'icon-shijuan',
          menuTag: '2',
          flag: this.$chnEngStatusCode.camp_signuplist,
          turnUrl: '/raceManagement/camp/campSignupList'
        }
      ],
      racingToolList2: [
        {
          rightTitle: '咨询信息',
          rightDesc: '可查看咨询的信息',
          icon: 'icon-baoming',
          menuTag: '3',
          flag: this.$chnEngStatusCode.camp_lnquiriesList,
          turnUrl: '/raceManagement/camp/campLnquiriesList'
        },
        {
          rightTitle: '常见问题',
          rightDesc: '可管理常见问题的信息',
          icon: 'icon-xiezuo',
          menuTag: '4',
          flag: this.$chnEngStatusCode.camp_problems,
          turnUrl: '/raceManagement/camp/campProblemsList'
        }
      ],
      nasccList: [
        {
          rightTitle: 'Spelling Bee World Cup拼词世界杯',
          rightDesc: '报名审核、遴选评测设置晋级',
          icon: 'icon-G',
          menuTag: '5',
          flag: this.$chnEngStatusCode.camp_signuplist,
          turnUrl: '/raceManagement/camp/gcscc'
        },
        {
          rightTitle: 'NASCC北美赛营地',
          rightDesc: '报名审核、合同管理、美签申请',
          icon: 'icon-N',
          menuTag: '4',
          flag: this.$chnEngStatusCode.camp_signuplist,
          turnUrl: '/raceManagement/camp/nasccSignupList'
        }
      ],
      winnerCampList: [],
      summerCampList: []
    }
  },
  created () {
    this.getCampList()
  },
  methods: {
    tapFn (index) {
      this.index = index
    },
    getCampList () {
      // const year = new Date().getFullYear()
      // 冠军冬训营
      camPage({ pageNum: 1, pageSize: 100, period: '2027' }).then((res) => {
        this.winnerCampList = res.data.list.filter(item => item.type === 0)
      }).catch((err) => {
        console.log('err', err)
      })
      // 赛事训练营
      camPage({ pageNum: 1, pageSize: 100, period: '2026' }).then((res) => {
        this.summerCampList = res.data.list.filter(item => item.type !== 0)
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 赛务工具点击回调
    racingToolClicked (itemData) {
      switch (itemData.flag) {
        case this.$chnEngStatusCode.camp_list_data: case this.$chnEngStatusCode.camp_signuplist: case this.$chnEngStatusCode.camp_lnquiriesList: case this.$chnEngStatusCode.nascc_signuplist: case this.$chnEngStatusCode.camp_problems:
          this.$router.push(itemData.turnUrl)
          break
        default:
          break
      }
    },
    handleToPage (item) {
      if (item.id === -1) return
      this.$router.push('/raceManagement/camp/campCampersData?campId=' + item.id)
    },
    handleToPage2 (item) {
      if (item.id === -1) return
      this.$router.push('/raceManagement/camp/campDetailsData?type=sale&campId=' + item.id)
    },
    goCampCampersData (id) {
      this.$router.push(
        {
          path: '/raceManagement/camp/campCampersData',
          query: {
            campId: id
          }
        }
      )
    },
    formatDate (date) {
      return date.slice(0, 10)
    },
    formatDate2 (date) {
      return date.slice(5, 10)
    }
  }
}
</script>

<style scoped lang="less">
.btns{
  // height: 30px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .btn{
    display: inline-block;
    min-width: 66px;
    padding: 0 10px;
    box-sizing: border-box;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border-radius: 6px;
    margin-right: 10px;
    margin-top: 6px;
    font-size: 12px;
    cursor: pointer;
    color: #fff;
    background-color: rgb(7, 17, 96);
    &:hover{
      box-shadow: inset 0 0 10px rgba(50, 72, 241, 0.8);
      color: rgb(7, 17, 96);
      background-color: #fff;
    }
  }
}
  .camp-item{
    width: 100%;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    &:hover{
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.4);
    }
    .status{
      font-size: 12px;
      font-weight: bold;
      color: #fff;
      background-color: #f00;
      padding: 2px 10px;
      position: absolute;
      right: 0;
      top: 0;
      border-radius: 0 10px 0 0;
    }
    .bg{
      width: 100%;
      height: 160px;
      object-fit: cover;
      border-radius: 10px 10px 0 0;
    }
    .panel{
      padding: 2px 12px 10px;
      .name{
        height: 40px;
        color: #000;
        font-size: 14px;
        font-weight: bold;
      }
      .flex{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #969696;
        font-size: 12px;
      }
      .date{
        color: #969696;
        font-size: 12px;
        margin-top: 8px;
        text-align: right;
      }
    }
  }
</style>
